import React from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import './App.css';

import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Sales from './pages/Sales';
import Projects from './pages/Projects';
import Inventory from './pages/Inventory';
import Timesheets from './pages/Timesheets';

function Sidebar() {
  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <h1>CGS</h1>
        <span>ERP System</span>
      </div>
      <nav className="sidebar-nav">
        <NavLink to="/" end className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
          <span className="nav-icon">▦</span> Dashboard
        </NavLink>
        <NavLink to="/customers" className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
          <span className="nav-icon">◈</span> Customers
        </NavLink>
        <NavLink to="/sales" className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
          <span className="nav-icon">◎</span> Sales
        </NavLink>
        <NavLink to="/projects" className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
          <span className="nav-icon">⬡</span> Projects
        </NavLink>
        <NavLink to="/inventory" className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
          <span className="nav-icon">▣</span> Inventory
        </NavLink>
        <NavLink to="/timesheets" className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
          <span className="nav-icon">⏱</span> Timesheets
        </NavLink>
      </nav>
      <div className="sidebar-footer">
        Creative Glass Systems<br />
        v1.0.0
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="app-layout">
        <Sidebar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/timesheets" element={<Timesheets />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;